module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n")
    ;  
         let localizedMinText = u.getLocalizedText(id, 'minText') || minText;
         let localizedMaxText = u.getLocalizedText(id, 'maxText') || maxText;  
        
    ; __append("\r\n\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px; min-width: 54px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\" style=\"width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; min-width: 54px;\">\r\n\r\n            <div class=\"v-slider\" style=\"background-color: ")
    ; __append(escapeFn( sliderColor ))
    ; __append("; height:")
    ; __append(escapeFn((u.extractNum(height)-10)))
    ; __append("px;\">\r\n            <a class=\"handle\" href=\"#\">\r\n                <img src=\"")
    ; __append( require('editor/buttons/vslider.png') )
    ; __append("\"/>\r\n            </a>\r\n            <div class=\"varrow\" style=\"border-right-color: ")
    ; __append(escapeFn( sliderColor ))
    ; __append("\"></div>\r\n            <ol class=\"ui-helper-reset\" role=\"presentation\">\r\n                <span class=\"v-slider-label max\"\r\n                      style=\"font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;  font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                              font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append("; color: ")
    ; __append(escapeFn( styleColorText))
    ; __append("\"\r\n                        >")
    ; __append(escapeFn(localizedMinText))
    ; __append("</span>\r\n\r\n                <span style=\"top:0%;border-color:")
    ; __append(escapeFn(tickColor))
    ; __append(";\" class=\"v-slider-tic\"></span>\r\n\r\n                ")
    ; 
                for (var i = 1; i < steps; i++) {
                    var position = (distance * i) + "%";
                
    ; __append("\r\n                    <span style=\"top:")
    ; __append(escapeFn( position ))
    ; __append("; border-color:")
    ; __append(escapeFn(tickColor))
    ; __append(";font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                            font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;  font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                            color: ")
    ; __append(escapeFn( styleColorText))
    ; __append("\" class=\"v-slider-tic\"></span>\r\n                ")
    ; }
    ; __append("\r\n\r\n                <span style=\"top:100%;border-color:")
    ; __append(escapeFn(tickColor))
    ; __append(";\" class=\"v-slider-tic\"></span>\r\n\r\n                <span class=\"v-slider-label min\"\r\n                        style=\"font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;  font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                                font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append("; color: ")
    ; __append(escapeFn( styleColorText))
    ; __append("\"\r\n                        >\r\n                    ")
    ; __append(escapeFn(localizedMaxText))
    ; __append("\r\n                </span>\r\n            </ol>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>")
  }
  return __output;

}